import React from "react";
import { CreditCard, Landmark, Bitcoin } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { Reveal } from "@/components/site/Reveal";

export const Payments = () => {
  const { t } = useLang();
  const p = t.payments;

  const blocks = [
    { key: "cards", icon: CreditCard, brands: ["VISA", "Mastercard", "AMEX"] },
    { key: "wire", icon: Landmark, brands: ["SWIFT", "WIRE"] },
    { key: "crypto", icon: Bitcoin, brands: ["BTC", "ETH", "USDT"] },
  ];

  return (
    <section id="payments" className="relative py-24 md:py-32 bg-[#0A0A0B] border-t border-white/10" data-testid="payments-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal className="max-w-3xl mb-16">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-gold" />
            <span className="flo-label">{p.label}</span>
          </div>
          <h2 className="font-serif-display text-white text-4xl sm:text-5xl md:text-6xl tracking-tighter leading-[0.98] mb-6">
            {p.title}
          </h2>
          <p className="text-zinc-400 leading-relaxed text-lg">{p.body}</p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {blocks.map((b, i) => {
            const Icon = b.icon;
            const data = p[b.key];
            return (
              <Reveal
                key={b.key}
                delay={i * 0.08}
                className="relative p-8 md:p-10 bg-[#18181B] border border-white/10 rounded-lg flex flex-col hover:border-gold/40 transition-colors duration-500"
                data-testid={`payment-${b.key}`}
              >
                <div className="flex items-center justify-between mb-8">
                  <Icon size={30} className="text-gold" strokeWidth={1.3} />
                  <span className="flo-label !text-[0.6rem] text-gold border border-gold/30 rounded-full px-3 py-1">
                    {data.tag}
                  </span>
                </div>
                <h3 className="font-serif-display text-white text-2xl md:text-3xl tracking-tight mb-4">{data.t}</h3>
                <p className="text-zinc-400 text-sm leading-relaxed flex-grow">{data.d}</p>
                <div className="flex flex-wrap gap-2 mt-8 pt-6 border-t border-white/10">
                  {b.brands.map((br) => (
                    <span
                      key={br}
                      className="text-xs tracking-wider text-zinc-300 border border-white/15 rounded px-3 py-1.5 font-medium"
                    >
                      {br}
                    </span>
                  ))}
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={0.2}>
          <p className="text-zinc-600 text-xs mt-10 max-w-2xl">{p.note}</p>
        </Reveal>
      </div>
    </section>
  );
};
